// Import modulari (solo auth + firestore) per ridurre JS inutilizzato e risorse che bloccano il rendering
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCGrUuZLQCxdbILfFQ2B9nfImq_Sy_euig",
    authDomain: "dbv-tarabto.firebaseapp.com",
    projectId: "dbv-tarabto",
    storageBucket: "dbv-tarabto.firebasestorage.app",
    messagingSenderId: "482353098885",
    appId: "1:482353098885:web:57a20d6f81188c0d2f39ec",
    measurementId: "G-RKTECNMCWH"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
// Persistenza offline; onSnapshot riceve prima la cache poi i dati server (merge automatico).
// Con connessione attiva, Firestore invia gli aggiornamenti dal server in tempo reale.
export const db = initializeFirestore(app, {
    localCache: persistentLocalCache(),
});
